module.exports = __webpack_public_path__ + "img/9_27.2a1cb6cb.png";